import React from 'react'
import './App.css';
// import Header from './components/Header'
// import PostList from './components/PostList'
// import PostForm from './components/PostForm'
// import Photos from './components/Photos'
import CryptoCurrency from './components/CryptoCurrency'

function App() {
  return (
    <div className="App">
      <CryptoCurrency />
    </div>
  );
}

export default App;
